// @flow
export const INFINITE_SCROLL_THEME_API = {
  root: '',
  item: ''
};
